import { render, staticRenderFns } from "./ModalEditOrder.vue?vue&type=template&id=10a1a3c3&scoped=true&"
import script from "./ModalEditOrder.vue?vue&type=script&lang=js&"
export * from "./ModalEditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1a3c3",
  null
  
)

export default component.exports